import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const TextField = (props: any) => {
  const { placeholder, value, register, type = "text", errors, label } = props;
  return (
    <>
      <div className={tw`w-full my-2 text-left mt-4`}>
        <label htmlFor="">{label}</label>
        <input
          placeholder={placeholder}
          defaultValue={value}
          {...register}
          type={type}
          
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        />
        {errors && (
          <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default TextField;
